import React from 'react';
import bg99select1 from "../../../assets/images/lotto99/bg99select1.png";
import {useLotto99} from "../../../store/lotto99/Lotto99Context";
import {imgUrl} from "../../../utils/asset";
import {getDate} from "../../../utils/dateUtils";
import CountdownTimer from "../../lotto12v2/CountdownTimer";
import groups_bg from "../../../assets/images/lotto99/groups_bg.png";
import {env} from "../../../env";

const MobileDashboardDrawingLotto99 = () => {
    const {drawing, t} = useLotto99();
    const {countDownTimer, isDrawing, detail, drawCode, drawAt, newResult} = drawing;
    let platformType = env.PLATFORM_TYPE;
    return (
        <div className="lotto99-mobile-drawing-wrapper">
            <div
                id="lotto-99-mobile"
                className="lotto99-bg"
                style={{
                    backgroundImage: `url(${bg99select1})`,
                }}
            >
                <div className="lotto99-drawing-board">
                    <div className="d-flex justify-content-between">
                        <div className="lotto99-drawing-header">
                            <div className="d-flex justify-content-center align-items-center">
                                <img className="logo2" src={imgUrl(`logo/${platformType}.png`)} alt=""/>
                                <span className="lotto-name kh-font-battambang font-moul">៩៩ សំណាង</span>
                            </div>
                            <div className="text-left">
                                <span className="p-2 date-sec-lo99">{getDate(drawAt)}</span>
                                <span className="p-2 ticket-sec-lo99">{drawCode}</span>
                            </div>
                        </div>

                        {!isDrawing ? (
                            <div className="draw-timer-wrap d-flex justify-content-center align-items-center">
                                <div className="d-block">
                                    <div>
                                        <CountdownTimer
                                            time={countDownTimer}
                                            isDrawing={isDrawing}
                                            className="countdown-lott99"
                                        />
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                    <span className="date-sec">
                                    {getDate(newResult?.drawAt)}
                                </span>
                                        <span className="ticket-sec">
                                    {newResult?.drawCode}
                                </span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="draw-timer-wrap d-flex justify-content-center align-items-center">
                                <div className="time-sec-title d-flex justify-content-center align-items-center">
                                    {t("labels:drawing.lotto90.drawing")}
                                </div>
                            </div>
                        )}
                    </div>

                    <div
                        style={{backgroundImage: `url(${groups_bg})`}}
                        className="lotto99-drawing-wrapper"
                    >
                        {detail?.map((e, i) => {
                            return (
                                <div
                                    key={i}
                                    className={`lotto99-drawing-number color-${i + 1} pos${i}`}
                                >
                                    <span>{e}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default MobileDashboardDrawingLotto99;